/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StartAutoCurationMutationVariables = Types.Exact<{
  input: Types.StartAutoCurationInput;
}>;


export type StartAutoCurationMutation = { __typename?: 'Mutation', startAutoCuration: { __typename?: 'DiscernDocumentModel', discern_document_id: string, vitall_patient_id: string, binary_resource_id: string, status: string, can_retry: boolean, grouping_state_json: Record<string, any>, created_at: string, updated_at: string, job?: { __typename?: 'DiscernJobModel', discern_job_id: string, job_id: string, start_time?: string | null, end_time?: string | null, created_at: string, updated_at: string, results: Array<{ __typename?: 'DiscernResultModel', discern_result_id: string, results_s3_key?: string | null, resource_name?: string | null, bbox_id?: string | null, sequence?: number | null, page_group: string, discern_sub_job_id?: string | null, group_index?: number | null, status: Types.DiscernResultStatus, record_date?: string | null, created_at: string, updated_at: string }> } | null } };

export type ListDiscernDocumentsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.GetDiscernDocumentsInput>;
}>;


export type ListDiscernDocumentsQuery = { __typename?: 'Query', listDiscernDocuments: Array<{ __typename?: 'DiscernDocumentModel', discern_document_id: string, binary_resource_id: string, status: string, can_retry: boolean, grouping_state_json: Record<string, any>, created_at: string, updated_at: string, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, user_id?: string | null, user?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string } | null } | null, job?: { __typename?: 'DiscernJobModel', discern_job_id: string, job_id: string, start_time?: string | null, end_time?: string | null, created_at: string, updated_at: string, results: Array<{ __typename?: 'DiscernResultModel', discern_result_id: string, results_s3_key?: string | null, bbox_id?: string | null, sequence?: number | null, resource_name?: string | null, page_group: string, discern_sub_job_id?: string | null, group_index?: number | null, status: Types.DiscernResultStatus, record_date?: string | null, created_at: string, updated_at: string }> } | null }> };

export type GetDiscernDocumentQueryVariables = Types.Exact<{
  input: Types.GetDiscernDocumentInput;
}>;


export type GetDiscernDocumentQuery = { __typename?: 'Query', getDiscernDocument: { __typename?: 'DiscernDocumentModel', discern_document_id: string, binary_resource_id: string, status: string, grouping_state_json: Record<string, any>, created_at: string, updated_at: string, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string } | null, job?: { __typename?: 'DiscernJobModel', discern_job_id: string, job_id: string, start_time?: string | null, end_time?: string | null, created_at: string, updated_at: string, results: Array<{ __typename?: 'DiscernResultModel', discern_result_id: string, results_s3_key?: string | null, resource_name?: string | null, bbox_id?: string | null, sequence?: number | null, page_group: string, discern_sub_job_id?: string | null, group_index?: number | null, status: Types.DiscernResultStatus, record_date?: string | null, created_at: string, updated_at: string }> } | null } };

export type GetDiscernResultQueryVariables = Types.Exact<{
  input: Types.GetDiscernResultInput;
  previewable?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetDiscernResultQuery = { __typename?: 'Query', getDiscernResult: { __typename?: 'DiscernResultModel', discern_result_id: string, results_s3_key?: string | null, resource_name?: string | null, page_group: string, discern_sub_job_id?: string | null, group_index?: number | null, status: Types.DiscernResultStatus, record_date?: string | null, created_at: string, updated_at: string, bbox_id?: string | null, sequence?: number | null, details?: { __typename?: 'DiscernResultDetailsModel', bounding_boxes?: Record<string, any> | null, ocr_data?: Record<string, any> | null } | null, pdf_url?: { __typename?: 'GetDownloadUrlResponse', url?: string | null, status: Types.DocumentHealthStatus } | null } };

export type CreateDiscernDocumentFromUploadMutationVariables = Types.Exact<{
  input: Types.CreateDiscernDocumentFromUploadInput;
}>;


export type CreateDiscernDocumentFromUploadMutation = { __typename?: 'Mutation', createDiscernDocumentFromUpload: { __typename?: 'DiscernDocumentModel', discern_document_id: string, vitall_patient_id: string, binary_resource_id: string, status: string, grouping_state_json: Record<string, any>, created_at: string, updated_at: string } };

export type UpdateDiscernDocumentMutationVariables = Types.Exact<{
  input: Types.UpdateDiscernDocumentInput;
}>;


export type UpdateDiscernDocumentMutation = { __typename?: 'Mutation', updateDiscernDocument: { __typename?: 'DiscernDocumentModel', discern_document_id: string, vitall_patient_id: string, binary_resource_id: string, status: string, grouping_state_json: Record<string, any>, created_at: string, updated_at: string, job?: { __typename?: 'DiscernJobModel', discern_job_id: string, job_id: string, start_time?: string | null, end_time?: string | null } | null } };

export type UpdateDiscernResultStatusMutationVariables = Types.Exact<{
  input: Types.UpdateDiscernResultStatusInput;
}>;


export type UpdateDiscernResultStatusMutation = { __typename?: 'Mutation', updateDiscernResultStatus: { __typename?: 'DiscernResultModel', discern_result_id: string, status: Types.DiscernResultStatus } };

export type DeleteDiscernDocumentMutationVariables = Types.Exact<{
  input: Types.DeleteDiscernDocumentInput;
}>;


export type DeleteDiscernDocumentMutation = { __typename?: 'Mutation', deleteDiscernDocument: { __typename?: 'DeleteDiscernDocumentModel', discern_document_id: string, vitall_patient_id: string } };


export const StartAutoCurationDocument = gql`
    mutation StartAutoCuration($input: StartAutoCurationInput!) {
  startAutoCuration(input: $input) {
    discern_document_id
    vitall_patient_id
    binary_resource_id
    status
    can_retry
    grouping_state_json
    created_at
    updated_at
    job {
      discern_job_id
      job_id
      start_time
      end_time
      created_at
      updated_at
      results {
        discern_result_id
        results_s3_key
        resource_name
        bbox_id
        sequence
        page_group
        discern_sub_job_id
        group_index
        status
        record_date
        created_at
        updated_at
      }
    }
  }
}
    `;
export type StartAutoCurationMutationFn = Apollo.MutationFunction<StartAutoCurationMutation, StartAutoCurationMutationVariables>;
export function useStartAutoCurationMutation(baseOptions?: Apollo.MutationHookOptions<StartAutoCurationMutation, StartAutoCurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAutoCurationMutation, StartAutoCurationMutationVariables>(StartAutoCurationDocument, options);
      }
export type StartAutoCurationMutationHookResult = ReturnType<typeof useStartAutoCurationMutation>;
export type StartAutoCurationMutationResult = Apollo.MutationResult<StartAutoCurationMutation>;
export type StartAutoCurationMutationOptions = Apollo.BaseMutationOptions<StartAutoCurationMutation, StartAutoCurationMutationVariables>;
export const ListDiscernDocumentsDocument = gql`
    query ListDiscernDocuments($input: GetDiscernDocumentsInput) {
  listDiscernDocuments(input: $input) {
    discern_document_id
    vitall_patient {
      vitall_patient_id
      user_id
      user {
        user_id
        first_name
        last_name
      }
    }
    binary_resource_id
    status
    can_retry
    grouping_state_json
    created_at
    updated_at
    job {
      discern_job_id
      job_id
      start_time
      end_time
      created_at
      updated_at
      results {
        discern_result_id
        results_s3_key
        bbox_id
        sequence
        resource_name
        page_group
        discern_sub_job_id
        group_index
        status
        record_date
        created_at
        updated_at
      }
    }
  }
}
    `;
export function useListDiscernDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<ListDiscernDocumentsQuery, ListDiscernDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDiscernDocumentsQuery, ListDiscernDocumentsQueryVariables>(ListDiscernDocumentsDocument, options);
      }
export function useListDiscernDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDiscernDocumentsQuery, ListDiscernDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDiscernDocumentsQuery, ListDiscernDocumentsQueryVariables>(ListDiscernDocumentsDocument, options);
        }
// @ts-ignore
export function useListDiscernDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListDiscernDocumentsQuery, ListDiscernDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListDiscernDocumentsQuery, ListDiscernDocumentsQueryVariables>;
export function useListDiscernDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDiscernDocumentsQuery, ListDiscernDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListDiscernDocumentsQuery | undefined, ListDiscernDocumentsQueryVariables>;
export function useListDiscernDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDiscernDocumentsQuery, ListDiscernDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDiscernDocumentsQuery, ListDiscernDocumentsQueryVariables>(ListDiscernDocumentsDocument, options);
        }
export type ListDiscernDocumentsQueryHookResult = ReturnType<typeof useListDiscernDocumentsQuery>;
export type ListDiscernDocumentsLazyQueryHookResult = ReturnType<typeof useListDiscernDocumentsLazyQuery>;
export type ListDiscernDocumentsSuspenseQueryHookResult = ReturnType<typeof useListDiscernDocumentsSuspenseQuery>;
export type ListDiscernDocumentsQueryResult = Apollo.QueryResult<ListDiscernDocumentsQuery, ListDiscernDocumentsQueryVariables>;
export const GetDiscernDocumentDocument = gql`
    query GetDiscernDocument($input: GetDiscernDocumentInput!) {
  getDiscernDocument(input: $input) {
    discern_document_id
    vitall_patient {
      vitall_patient_id
      patient_id
    }
    binary_resource_id
    status
    grouping_state_json
    created_at
    updated_at
    job {
      discern_job_id
      job_id
      start_time
      end_time
      created_at
      updated_at
      results {
        discern_result_id
        results_s3_key
        resource_name
        bbox_id
        sequence
        page_group
        discern_sub_job_id
        group_index
        status
        record_date
        created_at
        updated_at
      }
    }
  }
}
    `;
export function useGetDiscernDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetDiscernDocumentQuery, GetDiscernDocumentQueryVariables> & ({ variables: GetDiscernDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscernDocumentQuery, GetDiscernDocumentQueryVariables>(GetDiscernDocumentDocument, options);
      }
export function useGetDiscernDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscernDocumentQuery, GetDiscernDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscernDocumentQuery, GetDiscernDocumentQueryVariables>(GetDiscernDocumentDocument, options);
        }
// @ts-ignore
export function useGetDiscernDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDiscernDocumentQuery, GetDiscernDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDiscernDocumentQuery, GetDiscernDocumentQueryVariables>;
export function useGetDiscernDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiscernDocumentQuery, GetDiscernDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDiscernDocumentQuery | undefined, GetDiscernDocumentQueryVariables>;
export function useGetDiscernDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiscernDocumentQuery, GetDiscernDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDiscernDocumentQuery, GetDiscernDocumentQueryVariables>(GetDiscernDocumentDocument, options);
        }
export type GetDiscernDocumentQueryHookResult = ReturnType<typeof useGetDiscernDocumentQuery>;
export type GetDiscernDocumentLazyQueryHookResult = ReturnType<typeof useGetDiscernDocumentLazyQuery>;
export type GetDiscernDocumentSuspenseQueryHookResult = ReturnType<typeof useGetDiscernDocumentSuspenseQuery>;
export type GetDiscernDocumentQueryResult = Apollo.QueryResult<GetDiscernDocumentQuery, GetDiscernDocumentQueryVariables>;
export const GetDiscernResultDocument = gql`
    query getDiscernResult($input: GetDiscernResultInput!, $previewable: Boolean = false) {
  getDiscernResult(input: $input) {
    discern_result_id
    results_s3_key
    resource_name
    page_group
    discern_sub_job_id
    group_index
    status
    record_date
    created_at
    updated_at
    bbox_id
    sequence
    details {
      bounding_boxes
      ocr_data
    }
    pdf_url(previewable: $previewable) {
      url
      status
    }
  }
}
    `;
export function useGetDiscernResultQuery(baseOptions: Apollo.QueryHookOptions<GetDiscernResultQuery, GetDiscernResultQueryVariables> & ({ variables: GetDiscernResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscernResultQuery, GetDiscernResultQueryVariables>(GetDiscernResultDocument, options);
      }
export function useGetDiscernResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscernResultQuery, GetDiscernResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscernResultQuery, GetDiscernResultQueryVariables>(GetDiscernResultDocument, options);
        }
// @ts-ignore
export function useGetDiscernResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDiscernResultQuery, GetDiscernResultQueryVariables>): Apollo.UseSuspenseQueryResult<GetDiscernResultQuery, GetDiscernResultQueryVariables>;
export function useGetDiscernResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiscernResultQuery, GetDiscernResultQueryVariables>): Apollo.UseSuspenseQueryResult<GetDiscernResultQuery | undefined, GetDiscernResultQueryVariables>;
export function useGetDiscernResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiscernResultQuery, GetDiscernResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDiscernResultQuery, GetDiscernResultQueryVariables>(GetDiscernResultDocument, options);
        }
export type GetDiscernResultQueryHookResult = ReturnType<typeof useGetDiscernResultQuery>;
export type GetDiscernResultLazyQueryHookResult = ReturnType<typeof useGetDiscernResultLazyQuery>;
export type GetDiscernResultSuspenseQueryHookResult = ReturnType<typeof useGetDiscernResultSuspenseQuery>;
export type GetDiscernResultQueryResult = Apollo.QueryResult<GetDiscernResultQuery, GetDiscernResultQueryVariables>;
export const CreateDiscernDocumentFromUploadDocument = gql`
    mutation CreateDiscernDocumentFromUpload($input: CreateDiscernDocumentFromUploadInput!) {
  createDiscernDocumentFromUpload(input: $input) {
    discern_document_id
    vitall_patient_id
    binary_resource_id
    status
    grouping_state_json
    created_at
    updated_at
  }
}
    `;
export type CreateDiscernDocumentFromUploadMutationFn = Apollo.MutationFunction<CreateDiscernDocumentFromUploadMutation, CreateDiscernDocumentFromUploadMutationVariables>;
export function useCreateDiscernDocumentFromUploadMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscernDocumentFromUploadMutation, CreateDiscernDocumentFromUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscernDocumentFromUploadMutation, CreateDiscernDocumentFromUploadMutationVariables>(CreateDiscernDocumentFromUploadDocument, options);
      }
export type CreateDiscernDocumentFromUploadMutationHookResult = ReturnType<typeof useCreateDiscernDocumentFromUploadMutation>;
export type CreateDiscernDocumentFromUploadMutationResult = Apollo.MutationResult<CreateDiscernDocumentFromUploadMutation>;
export type CreateDiscernDocumentFromUploadMutationOptions = Apollo.BaseMutationOptions<CreateDiscernDocumentFromUploadMutation, CreateDiscernDocumentFromUploadMutationVariables>;
export const UpdateDiscernDocumentDocument = gql`
    mutation UpdateDiscernDocument($input: UpdateDiscernDocumentInput!) {
  updateDiscernDocument(input: $input) {
    discern_document_id
    vitall_patient_id
    binary_resource_id
    status
    grouping_state_json
    created_at
    updated_at
    job {
      discern_job_id
      job_id
      start_time
      end_time
    }
  }
}
    `;
export type UpdateDiscernDocumentMutationFn = Apollo.MutationFunction<UpdateDiscernDocumentMutation, UpdateDiscernDocumentMutationVariables>;
export function useUpdateDiscernDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscernDocumentMutation, UpdateDiscernDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscernDocumentMutation, UpdateDiscernDocumentMutationVariables>(UpdateDiscernDocumentDocument, options);
      }
export type UpdateDiscernDocumentMutationHookResult = ReturnType<typeof useUpdateDiscernDocumentMutation>;
export type UpdateDiscernDocumentMutationResult = Apollo.MutationResult<UpdateDiscernDocumentMutation>;
export type UpdateDiscernDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDiscernDocumentMutation, UpdateDiscernDocumentMutationVariables>;
export const UpdateDiscernResultStatusDocument = gql`
    mutation updateDiscernResultStatus($input: UpdateDiscernResultStatusInput!) {
  updateDiscernResultStatus(input: $input) {
    discern_result_id
    status
  }
}
    `;
export type UpdateDiscernResultStatusMutationFn = Apollo.MutationFunction<UpdateDiscernResultStatusMutation, UpdateDiscernResultStatusMutationVariables>;
export function useUpdateDiscernResultStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscernResultStatusMutation, UpdateDiscernResultStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscernResultStatusMutation, UpdateDiscernResultStatusMutationVariables>(UpdateDiscernResultStatusDocument, options);
      }
export type UpdateDiscernResultStatusMutationHookResult = ReturnType<typeof useUpdateDiscernResultStatusMutation>;
export type UpdateDiscernResultStatusMutationResult = Apollo.MutationResult<UpdateDiscernResultStatusMutation>;
export type UpdateDiscernResultStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDiscernResultStatusMutation, UpdateDiscernResultStatusMutationVariables>;
export const DeleteDiscernDocumentDocument = gql`
    mutation DeleteDiscernDocument($input: DeleteDiscernDocumentInput!) {
  deleteDiscernDocument(input: $input) {
    discern_document_id
    vitall_patient_id
  }
}
    `;
export type DeleteDiscernDocumentMutationFn = Apollo.MutationFunction<DeleteDiscernDocumentMutation, DeleteDiscernDocumentMutationVariables>;
export function useDeleteDiscernDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDiscernDocumentMutation, DeleteDiscernDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDiscernDocumentMutation, DeleteDiscernDocumentMutationVariables>(DeleteDiscernDocumentDocument, options);
      }
export type DeleteDiscernDocumentMutationHookResult = ReturnType<typeof useDeleteDiscernDocumentMutation>;
export type DeleteDiscernDocumentMutationResult = Apollo.MutationResult<DeleteDiscernDocumentMutation>;
export type DeleteDiscernDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDiscernDocumentMutation, DeleteDiscernDocumentMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListDiscernDocuments = withQueryResponseHandler(useListDiscernDocumentsQuery);
export const useGetDiscernDocument = withQueryResponseHandler(useGetDiscernDocumentQuery);
export const useGetDiscernResult = withQueryResponseHandler(useGetDiscernResultQuery);
export const useStartAutoCuration = withMutationResponseHandler(useStartAutoCurationMutation, "startAutoCuration");
export const useCreateDiscernDocumentFromUpload = withMutationResponseHandler(useCreateDiscernDocumentFromUploadMutation, "createDiscernDocumentFromUpload");
export const useUpdateDiscernDocument = withMutationResponseHandler(useUpdateDiscernDocumentMutation, "updateDiscernDocument");
export const useUpdateDiscernResultStatus = withMutationResponseHandler(useUpdateDiscernResultStatusMutation, "updateDiscernResultStatus");
export const useDeleteDiscernDocument = withMutationResponseHandler(useDeleteDiscernDocumentMutation, "deleteDiscernDocument");